(function () {
  function getBdlReviewSection(node) {
    if (!node) return null;
    if (node.matches && node.matches('[data-section-type="bdl-testimonials"]')) return node;
    if (node.querySelector) return node.querySelector('[data-section-type="bdl-testimonials"]');
    return null;
  }

  function destroyBdlReviews(section) {
    var slider = section.querySelector('[data-bdl-reviews-flickity]');
    if (slider && window.Flickity) {
      var existing = Flickity.data(slider);
      if (existing) existing.destroy();
    }
    section.dataset.bdlReviewsReady = '';
    section._bdlReviewsFlickity = null;
  }

  function equalizeBdlReviewHeights(section) {
    var inners = section.querySelectorAll('.bdl-reviews-card-inner');
    if (!inners.length) return;

    inners.forEach(function (inner) {
      inner.style.minHeight = '';
    });

    var maxHeight = 0;
    inners.forEach(function (inner) {
      maxHeight = Math.max(maxHeight, inner.getBoundingClientRect().height);
    });

    if (maxHeight > 0) {
      var height = Math.ceil(maxHeight) + 'px';
      inners.forEach(function (inner) {
        inner.style.minHeight = height;
      });
    }

    if (section._bdlReviewsFlickity) {
      section._bdlReviewsFlickity.resize();
    }
  }

  function bindReviewImageFallbacks(section) {
    section.querySelectorAll('.bdl-reviews-card-img').forEach(function (img) {
      if (img.dataset.reviewFallbackBound === 'true') return;
      img.dataset.reviewFallbackBound = 'true';

      img.addEventListener('error', function onError() {
        var fallback = img.getAttribute('data-review-fallback');
        if (fallback && img.src !== fallback) {
          img.src = fallback;
          return;
        }
        img.removeEventListener('error', onError);
      });
    });
  }

  function ensureReviewImages(section) {
    if (!section) return;

    section.querySelectorAll('.bdl-reviews-card-img').forEach(function (img) {
      if (img.getAttribute('src')) return;

      var lazySrc = img.getAttribute('data-flickity-lazyload');
      if (lazySrc) {
        img.setAttribute('src', lazySrc);
      }
    });
  }

  function primeReviewImages(section) {
    bindReviewImageFallbacks(section);
    ensureReviewImages(section);
  }

  function initBdlReviews(section) {
    if (!section || section.dataset.bdlReviewsReady === 'true') return;

    var slider = section.querySelector('[data-bdl-reviews-flickity]');
    var prev = section.querySelector('[data-bdl-reviews-prev]');
    var next = section.querySelector('[data-bdl-reviews-next]');

    if (!slider || !slider.children.length || !window.Flickity) return false;

    destroyBdlReviews(section);
    primeReviewImages(section);

    var flickity = new Flickity(slider, {
      wrapAround: true,
      draggable: true,
      pageDots: false,
      prevNextButtons: false,
      cellAlign: 'left',
      contain: false,
      adaptiveHeight: false,
      lazyLoad: 5,
      selectedAttraction: 0.14,
      friction: 0.8,
      dragThreshold: 7
    });

    section.dataset.bdlReviewsReady = 'true';
    section._bdlReviewsFlickity = flickity;

    if (prev) {
      prev.addEventListener('click', function () {
        flickity.previous();
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        flickity.next();
      });
    }

    section._bdlReviewsGoTo = function (index) {
      flickity.select(index);
    };

    flickity.on('select', function () {
      ensureReviewImages(section);
      equalizeBdlReviewHeights(section);
    });

    flickity.on('settle', function () {
      ensureReviewImages(section);
      equalizeBdlReviewHeights(section);
    });

    equalizeBdlReviewHeights(section);
    window.setTimeout(function () {
      ensureReviewImages(section);
      equalizeBdlReviewHeights(section);
    }, 350);

    if (!section._bdlReviewsResizeBound) {
      section._bdlReviewsResizeBound = true;
      var resizeTimer;
      window.addEventListener('resize', function () {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(function () {
          document.querySelectorAll('[data-section-type="bdl-testimonials"]').forEach(equalizeBdlReviewHeights);
        }, 150);
      });
    }

    return true;
  }

  function observeBdlReviews(section) {
    if (!section || section.dataset.bdlReviewsObserved === 'true') return;
    section.dataset.bdlReviewsObserved = 'true';

    primeReviewImages(section);

    if (initBdlReviews(section)) return;

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          if (initBdlReviews(section)) {
            observer.disconnect();
          }
        });
      }, { rootMargin: '240px 0px', threshold: 0 });

      observer.observe(section);
      return;
    }

    initBdlReviews(section);
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="bdl-testimonials"]').forEach(observeBdlReviews);
  }

  function scheduleInit() {
    initAll();
    window.setTimeout(initAll, 200);
    window.setTimeout(initAll, 800);
    window.setTimeout(initAll, 2000);
  }

  document.addEventListener('DOMContentLoaded', scheduleInit);
  document.addEventListener('page:loaded', scheduleInit);

  document.addEventListener('shopify:section:load', function (event) {
    var section = getBdlReviewSection(event.target);
    if (!section) return;
    section.dataset.bdlReviewsObserved = '';
    destroyBdlReviews(section);
    observeBdlReviews(section);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = getBdlReviewSection(event.target);
    if (!section) return;
    destroyBdlReviews(section);
  });
})();
